/* YEMEX LOGISTICS — theme scripts (no dependencies) */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.add('js');

  /* ---------- mobile drawer ---------- */
  var nav = doc.querySelector('.nav');
  var toggle = doc.querySelector('.nav__toggle');
  if (nav && toggle) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    doc.querySelectorAll('.nav__drawer a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  }

  /* ---------- hash links that belong to the home page ---------- */
  /* Menu links are written as plain hashes (#how-we-work, #service-area ...). On any
     template other than the home page there is no such element, so the click would
     silently do nothing. Send those visitors to the home page anchor instead. */
  doc.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var hash = a.getAttribute('href').slice(1);
    if (!hash || hash.indexOf('/') > -1) return;
    if (doc.getElementById(hash) || doc.getElementsByName(hash).length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    e.preventDefault();
    window.location.href = root + '#' + hash;
  }, true);

  /* ---------- reveal on scroll ---------- */
  var reveals = doc.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- multi-step quote form ---------- */
  var form = doc.querySelector('form[action*="/contact"], form.quote__form');
  if (!form) return;

  var panels = [].slice.call(form.querySelectorAll('.qpanel'));
  var steps = [].slice.call(form.querySelectorAll('.qstep'));
  var reviewList = form.querySelector('[data-review]');
  var current = 0;

  function fieldsOf(panel) { return [].slice.call(panel.querySelectorAll('input, select, textarea')); }

  function labelOf(field) {
    var wrap = field.closest('.field');
    if (!wrap) return field.name;
    var l = wrap.querySelector('label');
    return l ? l.textContent.replace('*', '').trim() : field.name;
  }

  function validatePanel(index) {
    var panel = panels[index];
    var ok = true;
    var first = null;
    fieldsOf(panel).forEach(function (f) {
      var bad = false;
      var wrap = f.closest('.field');
      if (f.hasAttribute('required')) {
        if (f.type === 'checkbox' ? !f.checked : !String(f.value || '').trim()) bad = true;
        if (f.type === 'email' && f.value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value)) bad = true;
      }
      if (wrap) wrap.classList.toggle('has-error', bad);
      if (bad) { ok = false; if (!first) first = f; }
    });
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
      if (first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return ok;
  }

  function clearErrors(panel) {
    [].slice.call(panel.querySelectorAll('.has-error')).forEach(function (w) { w.classList.remove('has-error'); });
  }

  function esc(v) {
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildReview() {
    if (!reviewList) return;
    var rows = [];
    panels.forEach(function (panel, i) {
      if (i === panels.length - 1) return;
      fieldsOf(panel).forEach(function (f) {
        var val = f.type === 'checkbox' ? (f.checked ? 'Yes' : '') : String(f.value || '').trim();
        if (!val) return;
        if (f.tagName === 'SELECT' && f.value === '') return;
        rows.push('<li><b>' + esc(labelOf(f)) + '</b><span>' + esc(val) + '</span></li>');
      });
    });
    reviewList.innerHTML = rows.length ? rows.join('') : '<li><b>No details yet</b><span>Go back and add your shipment details.</span></li>';
  }

  function goTo(index) {
    if (index > current && !validatePanel(current)) return;
    if (index === panels.length - 1) buildReview();
    clearErrors(panels[current]);
    current = Math.max(0, Math.min(index, panels.length - 1));
    panels.forEach(function (p, i) { p.classList.toggle('is-active', i === current); });
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === current);
      s.classList.toggle('is-done', i < current);
    });
    var top = form.getBoundingClientRect().top + (window.pageYOffset || 0) - 110;
    try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, top); }
  }

  form.addEventListener('click', function (e) {
    var next = e.target.closest('[data-next]');
    var back = e.target.closest('[data-back]');
    if (next) { e.preventDefault(); goTo(current + 1); }
    if (back) { e.preventDefault(); goTo(current - 1); }
  });

  /* Shopify's native contact form only persists name, email, phone, body.
     Pack every other answer into contact[body] so the quote email is complete. */
  var bodyField = form.querySelector('[name="contact[body]"]');
  var ownNotes = null;

  function composeBody() {
    if (!bodyField) return;
    if (ownNotes === null) ownNotes = String(bodyField.value || '').trim();
    var lines = [];
    panels.forEach(function (panel) {
      fieldsOf(panel).forEach(function (f) {
        if (!f.name || f.name === 'contact[body]' || f.name === 'contact[source]' || f.type === 'hidden') return;
        var val = f.type === 'checkbox' ? (f.checked ? 'Yes' : '') : String(f.value || '').trim();
        if (!val) return;
        var key = labelOf(f);
        if (key.length > 60) key = key.slice(0, 57).replace(/\s+\S*$/, '') + '…';
        lines.push(key + ': ' + val);
      });
    });
    var block = 'Quote request details\n' + lines.join('\n');
    bodyField.value = ownNotes ? block + '\n\nCustomer notes:\n' + ownNotes : block;
  }

  form.addEventListener('submit', function (e) {
    for (var i = 0; i < panels.length; i++) {
      if (!validatePanel(i)) {
        e.preventDefault();
        current = i;
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.classList.toggle('is-done', k < i); });
        return;
      }
    }
    composeBody();
  });

  /* keep native validation quiet until submit — we handle it ourselves */
  form.setAttribute('novalidate', 'novalidate');
  panels.forEach(function (p, i) { p.classList.toggle('is-active', i === 0); });
  steps.forEach(function (s, i) { s.classList.toggle('is-active', i === 0); });
})();
